<template>
  <div class="waterMakr">
    <Loading></Loading>
      <div class="areaMakr">
          <div class="title">{{$t('other.a559')}}</div>
          <div class="onting">
            <div style="margin:5px;"  :class="{'active':isActive == index}" v-for="(item,index) in waterMark" :key="index" @click="handlerImg(item.watermarkUrl,index)">
              <div class="imgbox">
                <img :src="item.watermarkUrl" alt="">
                <span class="del" @click="deleteWaterImg(item,index)">x</span>
              </div>
            </div>
            <div style="margin:5px;" >
              <div class="imgbox" style="border:1px solid #000">
                  <el-upload 
                  action=""
                  class="uploaImg"
                  :http-request="uploaWaterImg"
                  :on-success="handlePictureSuccess"
                  :show-file-list="false">
                  <img style="width:60%;margin-top:15px;" src="https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/ffbb897db0c04c3c87f1e6a8afaa5d04.png" alt="">
                  </el-upload>
              </div>
            </div>
          </div>
      </div>
      <div class="imageBox">
        <div class="title">
          <el-button size="" type="info" @click="recover()">{{$t('other.a560')}}</el-button>
          <el-button size="" type="primary" @click="presentAll()">{{$t('other.a561')}}</el-button>
          <el-button size="" type="primary" @click="present()">{{$t('other.a562')}}</el-button>
          <el-button size="" type="danger" @click="confirm()">{{$t('other.a563')}}</el-button>
          
        </div>
        <div class="area">
          <img  style="width:100%" :src="mainImg" alt="">
        </div>
        <div class="bottombox">
           <div :class="{'minPic':true,'active':mainIndex == index}" v-for="(item,index) in images" :key="index" @click="mainImgCopy=item.image,mainImg=item.image,mainIndex=index">
             <img style="width:100%" :src="item.image" alt="">
           </div>
           
        </div>
      </div>
  </div>
</template>

<script>
import api from '../api/api'
export default {
data(){
return{
  userId:JSON.parse(localStorage.getItem('userInfo')).userId,
  waterMark:[],
  mainImg:null,
  mainImgCopy:null,
  images:[],
  mainIndex:0,
  isActive:0,
}
},
components:{
  Loading:() => import(`./loadingBase`),
},
created(){
  this.images=JSON.parse(localStorage.getItem('warterImg'))
  
  this.mainImg=this.images[0].image
  this.mainImgCopy=this.images[0].image

  console.log('images',this.images);
  this.getWaterImg()
},
methods:{
  deleteWaterImg(item,index){
        this.$confirm(this.$t('other.a564'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            api
            .deleteWaterImg({
                userId:this.userId,
                watermarkIds:[item.id]
            })
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a565'))
            this.waterMark.splice(index,1)
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    },
  handlePictureSuccess(response, file, fileList){
      console.log('file',file)
  },
  uploaWaterImg(params){
        console.log(params)
        const _file=params.file
        const isLt2M=_file.size/1024/1024 < 2
        let formData=new FormData()
        formData.append('file',_file)
        console.log('formData',formData)

        api
        .uploadImg(formData)
        .then(res => {
            if(res.code === 200){
                console.log(res.data)
                this.waterMark.push({
                    watermarkUrl:res.data,
                    userId:this.userId
                })
                api
                .uploadWaterImg({
                    watermarkUrl:res.data,
                    userId:this.userId,
                    isUsed:true
                })
                .then(res => {
                    if(res.code === 200){
                        console.log('水印上传成功',res.data)
                    
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
                
            }else{
                this.$message.warning(res.msg)
            }
        })
    },
  confirm(){
    localStorage.setItem('warterImg',JSON.stringify(this.images))
      this.$router.push({
          path:'/addGoods',
          query:{
              productId:this.$route.query.productId,
              groupId:this.$route.query.groupId,
              type:this.$route.query.type,
              refreshType:1
          }
      })
  },
  //应用于所有图片
  presentAll(){
    this.showLoadingbase()
    let watermarkUrl=this.waterMark[this.isActive].watermarkUrl
    let list=[]
    this.images.forEach(p => {
      list.push(this.getWaterPiuture(p.image,watermarkUrl))
    })
    Promise.all(list).then(res => {
      console.log('999',res);
      this.hideLoadingbase()
      res.forEach((p,index) => {
        this.images[index].image=p
      })
    })

  },
  //仅应用于当前
  present(){
    this.showLoadingbase()
    let watermarkUrl=this.waterMark[this.isActive].watermarkUrl
    let originImg=this.images[this.mainIndex].image
    console.log('watermarkUrl',watermarkUrl);
    console.log('originImg',originImg);
    this.getWaterPiuture(originImg,watermarkUrl).then(res => {
      this.hideLoadingbase()
      this.images[this.mainIndex].image=res
      console.log('images',this.images);
    })
  },

  handlerImg(item,index){

    console.log(item);
    this.isActive=index
    this.mainImg=this.mainImgCopy
    this.showWaterImg(this.mainImg,item)
  },
  recover(){
    this.images=JSON.parse(localStorage.getItem('warterImg'))
    this.mainImg=this.images[0].image
    this.mainImgCopy=this.images[0].image
  },
  getWaterImg(){
      api
      .getWaterImg({
          userId:this.userId
      })
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      this.waterMark=res.data
 
      }else{
      this.$message.warning(res.msg)
      }
      })
  },
  //将原图与水印合并
  getWaterPiuture(originImg,waterImg){
        return new Promise((resolve) => {
            let that=this
            var canvas = document.createElement("canvas");
            canvas.width=800
            canvas.height=800
            let ctx=canvas.getContext('2d')
            let homeImg=originImg
            let picImg=new Image()
            picImg.setAttribute('crossOrigin', 'anonymous');
            picImg.src=homeImg
            picImg.onload = function() {
                ctx.drawImage(picImg,0,0,800,800);
                let base64=canvas.toDataURL('image/png')
                let image=new Image()
                image.src=waterImg
                image.setAttribute('crossOrigin', 'anonymous');
                image.onload = function() {
                    ctx.drawImage(image,0,0,800,800);
                    let base64=canvas.toDataURL('image/png')
                    var blob = that.dataURItoBlob(base64); // 上一步中的函数
                    var canvasOne = document.createElement('canvas');
                    var dataURL = canvasOne.toDataURL('image/jpeg', 0.5);
                    var fd = new FormData(document.forms[0]);
                    fd.append("file", blob, 'image.png');
                    fd.append('shopId',that.$route.query.shopId)
                    fd.append('isUploadToShopee',true)
                    api
                    .uploadImg(fd)
                    .then(res => {
                        if(res.code == 200) {
                            resolve(res.data.image_info_list[0].image_info.image_url_list[0].image_url)
                        }else{
                            that.$message.warning(res.msg)
                        }
                    })
                }  
            }
        })

    },

    dataURItoBlob(base64Data) {
        var byteString;
        if (base64Data.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(base64Data.split(',')[1]);
        else
        byteString = unescape(base64Data.split(',')[1]);
        var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], {type:mimeString});
    },

    showWaterImg(originImg,waterImg){
      let that=this
      var canvas = document.createElement("canvas");
      canvas.width=800
      canvas.height=800
      let ctx=canvas.getContext('2d')
      let homeImg=originImg
      let picImg=new Image()
      picImg.setAttribute('crossOrigin', 'anonymous');
      picImg.src=homeImg
      picImg.onload = function() {
          ctx.drawImage(picImg,0,0,800,800);
          let base64=canvas.toDataURL('image/png')
          let image=new Image()
          image.src=waterImg
          image.setAttribute('crossOrigin', 'anonymous');
          image.onload = function() {
              ctx.drawImage(image,0,0,800,800);
              let base64=canvas.toDataURL('image/png')
              that.$nextTick(() => {
                that.mainImg=base64
              })
              
          }  
      }
    },

}
}

</script>
<style lang="scss" scoped>
.waterMakr{
  margin: 50px 0 0 0;
  display: flex;
  height: calc(100vh - 50px);
  

  .areaMakr{
    width: 25%;
    background-color: #eee;

    .title{
      background-color: #fff;
      padding: 10px 15px;
      font-size: 18px;
      font-weight: 600;
    }
    

    .onting{
      display: flex;
      flex-wrap: wrap;

      .active{
        border: 3px solid #409eff;

      }
    }

    .imgbox{
      width: 80px;
      height: 80px;
      position: relative;

      .del{
        position: absolute;
        display: inline-block;
        right: 2px;
        top: 2px;
        width: 20px;
        text-align: center;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
        background-color: #fff;
        cursor: pointer;
        
      }

      img{
        width: 100%;
      }
    }
    
  }

  .imageBox{
    flex: 1;
    position: relative;

    .bottombox{
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 20px;


      .minPic{
        width: 60px;
        height: 60px;
        margin: 10px;
        cursor: pointer;
      }

      .active{
        border: 2px solid red;
      }
    }

    

    .title{
      background-color: #fff;
      padding: 10px 15px;
      font-size: 18px;
      text-align: right;
      box-shadow: 0px 2px 8px 0px rgba(92, 91, 91, 0.15);

      .desc{
        margin: 0 10px;
        background-color: #409eff;
        color: #fff;
        font-size: 15px;
        padding: 3px 10px;
        border-radius: 3px;
        cursor: pointer;
      }
    }

    .area{
      width: 450px;
      height: 450px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }
}
</style>